var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('button',{staticClass:"btn btn-sm btn-light px-50 py-50",on:{"click":function($event){return _vm.params.onClick(_vm.params.data)}}},[_c('feather-icon',{attrs:{"icon":"EyeIcon"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }